// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".asset-preview.non-shareable[data-v-bbd9a8ec]{color:#495057}.asset-preview.non-shareable .thumbnail[data-v-bbd9a8ec]{height:132px}.asset-preview.non-shareable .thumbnail img[data-v-bbd9a8ec]{max-height:130px}.asset-preview:hover .card-body .asset-info.stay[data-v-bbd9a8ec]{opacity:1}", ""]);
// Exports
module.exports = exports;
